import { render, staticRenderFns } from "./InvoiceRowsHeader.vue?vue&type=template&id=65d20502&"
import script from "./InvoiceRowsHeader.vue?vue&type=script&lang=js&"
export * from "./InvoiceRowsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports